if (!customElements.get('account-login')) {
  customElements.define(
    'account-login',
    class AccountLogin extends HTMLElement {
      constructor() {
        super();
        window.initScriptOnDemand(this, this.init.bind(this), 100);
      }

      init() {
        console.log('AccountLogin init');
        this.recoverForm = this.querySelector('#recover');
        this.loginForm = this.querySelector('#login');

        console.log('AccountLogin recoverForm', this.recoverForm);
        console.log('AccountLogin loginForm', this.loginForm);

        if (!this.recoverForm || !this.loginForm) return;

        this.addEventListener('click', this.onLinkClick.bind(this));

        if (window.location.hash === '#recover') {
          this.showRecover();
        } else {
          this.showLogin();
        }
      }

      onLinkClick(event) {
        console.log('AccountLogin onLinkClick');
        const link = event.target.closest('[href="#recover"], [href="#login"]');
        if (!link || !this.contains(link)) return;

        event.preventDefault();

        if (link.getAttribute('href') === '#recover') {
          this.showRecover();
          history.replaceState(null, '', '#recover');
        } else {
          this.showLogin();
          history.replaceState(null, '', '#login');
        }
      }

      showRecover() {
        this.recoverForm.hidden = false;
        this.loginForm.hidden = true;
      }

      showLogin() {
        console.log('AccountLogin showLogin');
        this.recoverForm.hidden = true;
        this.loginForm.hidden = false;
      }
    }
  );
}

(function () {
  if (window.__dreamerCustomerAccountsBound) return;
  window.__dreamerCustomerAccountsBound = true;

  function clickGrowaveButton(hostSelector, innerSelector) {
    const host = document.querySelector(hostSelector);
    const button = host && host.shadowRoot && host.shadowRoot.querySelector(innerSelector);
    if (!button) return false;
    button.click();
    return true;
  }

  document.addEventListener('click', function (event) {
    const claim = event.target.closest('.balance_point_opener');
    if (!claim) return;

    event.preventDefault();
    if (!clickGrowaveButton('.gw-rd-popup-widget-placeholder', 'button.gw-rd-popup-widget-launcher-btn')) {
      window.location.href = '/pages/dreamer-rewards';
    }
  });
})();
